<template>
  <div class="mb-4">
    <button class="btn btn-info btn-icon mw" @click="sendRequest">
      {{ "create_query" | setText("Сформировать заявку") }}
    </button>
  </div>
</template>
<script>
import {
  logger,
  errorNotify,
  toFormData,
  dateConvert,
  addMonth,
} from "@/plugins/functions";

export default {
  methods: {
    errorSimurg(error = -1) {
      switch (error) {
        case 0:
          return "Успешная обработка запроса";
          break;

        case -32504:
          return "Недостаточно привилегий для выполнения метода";
          break;
        case 0:
          return "Успешная обработка запроса";
          break;
        case 1:
          return "Ошибка в json формате";
          break;
        case 2:
          return "Транзакция # - уже существует в базе";
          break;
        case 3:
          return "Транзакция # - обрабатывается";
          break;
        case 4:
          return "Ошибка в аутентификации";
          break;
        case 5:
          return "Ошибка в номере продукта";
          break;
        case 6:
          return "Ошибка в расчете премии";
          break;
        case 7:
          return "Ошибка в наименовании страхователя";
          break;
        case 8:
          return "Ошибка в страховой UZSме договора";
          break;
        case 9:
          return "Ошибка в формате даты";
          break;
        case 10:
          return "Ошибка в дате начало страхования";
          break;
        case 11:
          return "Ошибка в дате конца страхования";
          break;
        case 12:
          return "Ошибка в периоде страхования";
          break;
        case 13:
          return "Закрытый период даты заключения";
          break;
        case 14:
          return "Системная ошибка при обработке запроса";
          break;
        case 15:
          return "Ошибка в типе клиента";
          break;
        case 16:
          return "Ошибка в ИНН клиента";
          break;
        case 17:
          return "Ошибка в наименовании клиента";
          break;
        case 18:
          return "Ошибка в номере телефона клиента";
          break;
        case 19:
          return "Ошибка в адресе клиента";
          break;
        case 20:
          return "Ошибка в паспорте клиента";
          break;
        case 21:
          return "Ошибка в дне рождении клиента";
          break;
        case 22:
          return "Ошибка в МФО банка";
          break;
        case 23:
          return "Ошибка в ИНН банка";
          break;
        case 24:
          return "Банк не найден";
          break;
        case 25:
          return "Ошибка в общей UZSме кредита";
          break;
        case 26:
          return "Ошибка в поле клиента";
          break;

        default:
          return "Неизвестная ошибка";
          break;
      }
    },
    async sendRequest() {
      logger(this.$http, {
        name: `Формирование запроса в страховую`,
        description: "",
        model_type: this.type,
        model_id: this.data.id,
      });

      //INIT
      const url = `${this.currentRequest.service.api_endpoint_url}InitiateTransactionRequest`;
      const method = "post";

      //DATA
      console.log(this.data);
      let data = {
        subject: "P",
        customer: {
          pinfl: this.data.user_pinfl,
          passport: this.data.user_passport,
          full_name: `${this.data.user_first_name} ${this.data.user_last_name}`,
          phone: this.data.user_phone,
          address: this.data.user_address,
          birth_date: dateConvert(this.data.user_birthday),
          gender: this.data.user_gender ? this.data.user_gender : 0,
        },
        loan_info: {
          object_brand: `№ ${this.data.blank_number} от ${dateConvert(
            this.data.blank_date
          )}`,
          claim_id: this.currentRequest.id,
          loan_type: "32",
          loan_total: this.data.product_price,
          loan_amount: this.data.loan_amount,
          loan_term: this.data.loan_period,

          blank_number: this.data.blank_number,
          blank_date: this.data.blank_date,

          s_date: dateConvert(this.data.start_date),
          e_date: dateConvert(addMonth(this.data.end_date, 1)),

          object_name: this.data.product_name,
        },
        organization: {
          mfo: "00440",
          inn: "201788904",
          name: 'OOO "COSCOM"',
        },
      };

      this.$dialog
        .confirm(`${this.data.product_name}`, {
          okText: "Верно | To'g'ri",
          cancelText: "Нет | Yo'q",
        })
        .then(() => {
          this.$loading(true);

          var instance = this.$http.create();
          delete instance.defaults.headers.common["Authorization"];
          delete instance.defaults.headers.common["bid"];
          delete instance.defaults.headers.common["localization"];
          delete instance.defaults.headers.common["shop"];
          delete instance.defaults.headers.common["device"];
          delete instance.defaults.headers.common["tab"];
          delete instance.defaults.headers.common["root"];
          delete instance.defaults.headers.common["version"];
          const config = {
            method: method,
            url: url,
            data: data,
            headers: {
              // Ваши заголовки, которые нужно удалить
              common: {
                Authorization:
                  "Basic " +
                  btoa(
                    this.currentRequest.service.api_login +
                      ":" +
                      this.currentRequest.service.api_password
                  ),
              },
            },
          };

          //REQUEST
          return instance(config)
            .then((response) => {
              this.$loading(false);
              const responseData = response.data;

              if (responseData && responseData.result == 0) {
                this.$emit("input", {
                  service_request: {
                    state: "sent",
                    service: "semurg",
                    exchange_id: responseData.contract_id,
                    response: JSON.stringify(responseData),
                    body: JSON.stringify(data),
                  },
                });
              }

              this.$notify({
                title: "Система страхования",
                message: this.errorSimurg(responseData.result),
                icon: "ti-info",
                horizontalAlign: "right",
                verticalAlign: "top",
              });

              return responseData;
            })
            .catch((error) => {
              this.$loading(false);
              return errorNotify(error, this.notify);
            })
            .finally(() => {});
        })
        .catch(() => {});
    },
  },
  props: ["value", "data", "currentRequest", "type"],
};
</script>
<style>
</style>
 